<div class="kt-portlet container">
	<div class="kt-portlet__head">
		<div class="encabezado mt-3">
			<h1 class="titulo"><i class="fas fa-satellite"></i>&nbsp;{{titulo}}</h1>
		</div>
		<div class="mt-3">
			<kt-boton-exportar-tabla [tipoBoton]="'grid'" [nombreArchivo]="'Transmisiones'" [datos]="datosReporte"
				[buttonDisabled]="isDisabled">
			</kt-boton-exportar-tabla>
		</div>
	</div>
	<div class="kt-portlet__body">
		<form [formGroup]="busquedaForm">
			<div class="row">
				<div class="col-md-3 form-group">
					<i class="fas fa-barcode"></i>&nbsp;
					<label>IMEI</label>
					<input matInput formControlName="imei" class="form-control">
					<span matPrefix></span>
				</div>
				<div class="col-md-3 form-group">
					<i class="fas fa-bars"></i>&nbsp;
					<label>Cantidad de Registros</label>
					<input matInput formControlName="cantidadRegistros" class="form-control">
				</div>
				<div class="form__actions col-md-6 mt-3">
					<button id="agregarBoton" mat-raised-button class="mt-3  btn btn-success"
						(click)="obtenerListaTransmisiones()" style="margin-right: 15px;"><i
							class="fas fa-search"></i>&nbsp;Buscar</button>&nbsp;
					<button mat-raised-button (click)="regresar()"><i class="fas fa-times"></i>&nbsp;Cancelar</button>
				</div>
			</div>
		</form>
		<mat-divider></mat-divider>
		<div class="kt-section mt-3">
			<div class="kt-section__content">
				<div class="contenedor-modal">
					<div class="data-grid">
						<dx-data-grid id="gridContainer" [columnHidingEnabled]="true" [dataSource]="listaTransmisiones"
							[showBorders]="true" [rowAlternationEnabled]="true">
							<dxo-paging [pageSize]="7"></dxo-paging>
							<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[7, 10, 50, 100]"
								[showInfo]="true">
							</dxo-pager>
							<dxo-group-panel [emptyPanelText]="mensajeAgrupar" [visible]="true"></dxo-group-panel>
							<dxo-filter-row [visible]="showFilterRow"></dxo-filter-row>
							<dxo-header-filter [visible]="showHeaderFilter"></dxo-header-filter>
							<dxi-column caption="Acciones" cellTemplate="acciones" alignment="center">
							</dxi-column>
							<dxi-column dataField="imei" caption="IMEI" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="nombreCliente" caption="Cliente" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="fechaHora" caption="Fecha y Hora" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="estado" caption="Estado" alignment="center" cellTemplate="color">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="lat" caption="Latitud" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="lng" caption="Longitud" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<div *dxTemplate="let row of 'acciones'">
								<ng-container>
									<dx-button valueExpr="id" id="botonWhiteBlue" class="btnAcciones"
										(click)="ubicarMapa(row.data)">
										<i class="fas fa-eye"></i>
									</dx-button>
								</ng-container>
							</div>
							<div *dxTemplate="let p of 'color'" class="offset-md-4">
								<p *ngIf="p.data.estado === 'Alerta Primaria'" class="rojo">{{p.data.estado}}</p>
								<p *ngIf="p.data.estado === 'Movimiento'" class="verde">{{p.data.estado}}</p>
								<p *ngIf="p.data.estado === 'Exceso de Velocidad'" class="azul">{{p.data.estado}}</p>
								<p *ngIf="p.data.estado === 'Detenido mas de 60 min'" class="naranja">{{p.data.estado}}</p>
								<p *ngIf="p.data.estado === 'Detenido'" class="gris">{{p.data.estado}}</p>
								<p *ngIf="p.data.estado === 'Falta de Energía'" class="rosa">{{p.data.estado}}</p>
							</div>
						</dx-data-grid>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<!--<div [hidden]="verMapa" class="map-content kt-portlet" id="map-content">
	<div id="map" class="map ">
	</div>
</div>-->
<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadingVisible" [showIndicator]="true"
	[showPane]="true" [shading]="true" [closeOnOutsideClick]="false">
</dx-load-panel>
